export enum Institution {
    UNIHORIZONTES = 'unihorizontes',
    CELSO_LISBOA = 'celso-lisboa',
    UNIFG = 'unifg',
    ANHANGUERA_UNOPAR = 'anhanguera-unopar',
    AMPLI = 'ampli',
    UNOPAR = 'unopar',
    UNIC = 'unic',
    PITAGORAS = 'pitagoras',
    ANHANGUERA = 'anhanguera',
    MC = 'mc',
    FASEH = 'faseh',
    UNIBH = 'unibh',
    AGES = 'ages',
    UNICURITIBA = 'unicuritiba',
    FMU = 'fmu',
    UNA = 'una',
    UNIFACS = 'unifacs',
    UNIDERP = 'uniderp',
    CENTRO_UNIVERSITARIO_FACID_WYDEN = 'centro-universitario-facid-wyden',
    CENTRO_UNIVERSITARIO_TOLEDO = 'centro-universitario-toledo',
    ESTACIO = 'estacio',
    UNIRITTER = 'uniritter',
    FPB = 'fpb',
    UAM = 'uam',
    UNIME = 'unime',
    CENTRO_UNIVERSITARIO_FANOR_WYDEN = 'centro-universitario-fanor-wyden',
    EADWYDEN = 'eadwyden',
    CENTRO_UNIVERSITARIO_FBV_WYDEN = 'centro-universitario-fbv-wyden',
    FACULDADE_DE_IMPERATRIZ_WYDEN = 'faculdade-de-imperatriz-wyden',
    USJT = 'usjt',
    UNIBTA = 'unibta',
    CENTRO_UNIVERSITARIO_METROCAMP_WYDEN_UNIMETROCAMP_WYDEN = 'centro-universitario-metrocamp-wyden-unimetrocamp-wyden',
    FACULDADE_IDEAL_WYDEN = 'faculdade-ideal-wyden',
    CENTRO_UNIVERSITARIO_RUY_BARBOSA_WYDEN_UNIRUY_WYDEN = 'centro-universitario-ruy-barbosa-wyden-uniruy-wyden',
    FACULDADE_MARTHA_FALCAO_WYDEN = 'faculdade-martha-falcao-wyden',
    CENTRO_UNIVERSITARIO_FAVIP_WYDEN = 'centro-universitario-favip-wyden',
    UNYLEYA = 'unyleya',
    FADERGS = 'fadergs',
    UNP = 'unp',
    UNISUL = 'unisul',
    UNISOCIESC = 'unisociesc',
    IBMR = 'ibmr'
}

export enum InstitutionpartnerId {
	ANIMA = '96e02258-2a21-4dc0-b46a-b83b24665406'
}
const institutionSlugToIdMap: {[key:string]:string} = {
    'unihorizontes': 'e3b2e07e-c325-4a63-a651-5c2b11be5734', 
    'celso-lisboa': '952dcc57-82b0-4ea2-a308-3405097ce045', 
    'unifg':'e6c8a269-1c89-458b-8935-faa785f660a7', 
    'anhanguera-unopar':'57164552-3035-4cd5-a429-efb526628bea', 
    'ampli':'1c0a77c4-f94b-4bd3-b99b-56b94ee696d7', 
    'unopar':'d2a127b7-198d-4a51-a466-11d6df97c477', 
    'unic':'fccdcb05-11ac-49aa-adc1-c26b571172b9', 
    'pitagoras':'cd28e073-017c-4c4b-bfe0-8b864e008793', 
    'anhanguera':'ec52ab2a-cef0-46af-8289-85495e9b75ba', 
    'mc':'93d0fb6d-62e9-4987-8724-a6d49b464669', 
    'faseh':'2d6b7f12-0a61-4ac7-8811-b6d2cd351911', 
    'unibh':'1abc56c7-812e-4c71-8cd8-258f82a1c31f', 
    'ages':'afdff7b0-cbfb-4e19-a2f2-7a681823f2a7', 
    'unicuritiba':'d7dd8104-03b2-4b54-b8ea-80105f7af0e5', 
    'fmu':'e11dd7d3-af2b-4ef5-8181-f1a004260f25', 
    'una':'54c0127a-6886-43eb-bde8-23a2535437c2', 
    'unifacs':'e47218fb-110b-4951-b6f0-18e5d21ec41a', 
    'uniderp':'5eb2ca5e-c26d-4340-b0de-3dfd71e92454', 
    'centro-universitario-facid-wyden':'f3fc0b02-2178-4b94-ab0e-09f105b2610c', 
    'centro-universitario-toledo':'5991bcf1-43d3-4e2c-ae97-c89387a14e33', 
    'estacio':'3a463437-fe6b-433b-a4e4-30cdbc466ca4', 
    'uniritter':'5785f491-9858-4b29-9794-096d37015f6e', 
    'fpb':'0735e2fe-1674-478b-80b1-01ab5b2e6f0c', 
    'uam':'94b1e210-dc8a-4905-a8f4-a998648a7e32', 
    'unime':'020c5cb2-7edd-420e-ae41-901b4bd992d9', 
    'centro-universitario-fanor-wyden':'0fd43140-2916-41ab-9aca-89e190743ace', 
    'eadwyden':'3750567f-8b7b-4e64-b545-fc03ad0c0806', 
    'centro-universitario-fbv-wyden':'73edc7c7-516a-450d-b9c6-e47320b660f4', 
    'faculdade-de-imperatriz-wyden':'89491e43-08ad-46b3-aa1e-8abee2ccc5f0', 
    'usjt':'8b816491-79a6-4d7c-ac96-583d19431927', 
    'unibta':'eafa3497-d933-4575-8f8d-aecd6892518f', 
    'centro-universitario-metrocamp-wyden-unimetrocamp-wyden':'c6f6555b-f0a1-4fd8-b87c-002f86400d45', 
    'faculdade-ideal-wyden':'8e2833eb-d85c-427a-af1d-64360e30a599', 
    'centro-universitario-ruy-barbosa-wyden-uniruy-wyden':'d9870afb-8a69-4731-a4c2-501edfada46e', 
    'faculdade-martha-falcao-wyden':'9e8de8da-3a40-4629-84ce-8dbc261a05eb', 
    'centro-universitario-favip-wyden':'7c17a976-fc10-43df-9a22-15863fcc724b', 
    'unyleya':'d7d8210d-d2a7-4358-b11f-e224a25c54e1', 
    'fadergs':'05f31200-b5ca-43e9-8ee6-64036e7ef8b4', 
    'unp':'03b5ead4-5dfc-420d-b027-ceff9ccd9322', 
    'unisul':'979cade7-8115-48bd-9970-783bf5e759e8', 
    'unisociesc':'d8d6da74-b39c-455d-9bfa-74c1f3ebaae9', 
    'ibmr':'443a0e37-882b-4296-b0dd-35c20fd35045'
} 

export function getInstitutionIdBySlug(slug: string): string | null {
    if (institutionSlugToIdMap.hasOwnProperty(slug)) {
        return institutionSlugToIdMap[slug];
    }
    return null;
}

export function hasInstitutions(institutionId: string, hiddenInstitutionSlugs: Institution[]): boolean {
    const hiddenInstitutionIds = hiddenInstitutionSlugs.map(slug => getInstitutionIdBySlug(slug));
    return hiddenInstitutionIds.includes(institutionId);
}
